<template>
  <div id="finance-base" class="flex">
    <div class="flex flex-col flex-grow">
      <div
        id="finance-header"
        class="sticky left-0 z-50 flex items-center flex-shrink-0 px-6 border-b top-18 h-18 bg-pure-white border-slate-400"
        :style="{ width: 'calc(100vw - 0.5rem)' }"
      >
        <div class="flex items-center gap-2">
          <BlTextTitle3 text="Finance" />
        </div>
      </div>

      <div id="finance-body">
        <CreditsManagement />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CreditsManagement from "./CreditsManagement.vue";

import BlTextTitle3 from "../BlTextTitle3.vue";

export default {
  name: "Finance",
  components: { CreditsManagement, BlTextTitle3 },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"])
  },
  watch: {},
  async mounted() {
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }
    if (!this.currentCenter.enable_appointment) {
      return this.$router.push({ name: "Clients" });
    }
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/finance/Finance.vue